import React from 'react';
import Carone from "../../images/car/car-one.jpg";
import Cartwo from "../../images/car/car-two.jpg";
import Carthree from "../../images/car/car-three.jpg";
import Carfour from "../../images/car/car-four.jpg";
import Carfive from "../../images/car/car-five.jpg";
import Carsix from "../../images/car/car-six.jpg";
import Carseven from "../../images/car/car-seven.jpg";
import Carnine from "../../images/car/car-nine.png";
import Carten from "../../images/car/car-ten.jpg";
// import Careleven from "../../images/car/car-eleven.jpg";
import "./car.css";


export default function CarProtectionPage() {
    return (
        <div className="w-full overflow-hidden font-sans text-gray-800 !bg-[#ffffff]">
            <section className="relative w-full h-[100vh]">
                <img src={Carone} alt="Hero" className="absolute inset-0 w-full h-full object-cover" />

                <div className="absolute bottom-0 left-0 right-0 flex justify-center pb-10">
                    <div className="px-6 py-6 text-center rounded-md max-w-3xl mx-auto">
                        <h2
                            className="text-3xl sm:text-4xl font-bold tracking-widest mb-4"
                            style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                        >
                            OUR SERVICES
                        </h2>
                        <p className="text-lg sm:text-xl text-gray-800 leading-relaxed">
                            We offer a wide range of services from paint protection film and window
                            film installation to detailing and storage. Our experts know how to
                            keep your vehicle looking flawless.
                        </p>
                    </div>
                </div>
            </section>


            {/* Description */}


            {/* Sections */}
            <div className="space-y-12">
                {/* Section 1 */}
                <div className='text-center max-w-3xl mx-auto'>
                    <h2
                        className="text-3xl font-bold tracking-widest"
                        style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                    >
                        PAINT PROTECTION FILM (PPF)
                    </h2>
                </div>
                <div className="md:flex items-center justify-center">
                    <img src={Cartwo} alt="Preparation" className="md:w-1/2 w-full rounded-lg" />
                    <div className="md:w-1/3 w-full p-10 bg-white shadow-lg text-center justify-center">
                        <h2
                            className="text-2xl font-bold tracking-widest p-8"
                            style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                        >
                            PREPARATION
                        </h2>
                        <p className="text-gray-800 text-xl leading-normal text-justify" style={{ wordSpacing: '0', hyphens: 'auto' }}>
                            We consider this to be the most important stage in any PPF process.
                            All cars are initially washed to remove all loose dirt on the painted and carbon surfaces.
                            These surfaces are then further decontaminated by applying a claybar to them.
                            The final stage is to use various compounds via an orbital polisher to remove any swirls
                            or defects in the surfaces: the objective is to achieve a flawless surface prior to PPF application.</p>
                    </div>
                </div>

                {/* Section 2 */}
                <div className="md:flex md:flex-row-reverse items-center justify-center px-4 py-4">
                    <img src={Carthree} alt="Non-invasive" className="md:w-1/2 w-full rounded-lg" />
                    <div className="md:w-1/3 w-full p-8 bg-white shadow-lg text-center justify-center">

                        <h2
                            className="text-2xl font-bold tracking-widest p-8"
                            style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                        >
                            NON-INVASIVE PROCESS
                        </h2>
                        <p className="text-gray-800 text-xl leading-normal text-justify" style={{ wordSpacing: '0', hyphens: 'auto' }}>
                            Our philosophy is not to remove any body panels, parts, wing mirrors or lights when applying PPF.
                            We use software and a plotter to produce pre-cut templates that blend seamlessly with the surfaces.
                            Through our experience and scale we’ve produced enhancements to the templates to assist in the installation and areas covered/protected.
                            We also possess the skills inhouse to produce bespoke templates for rare classic/race/low volume cars</p>
                    </div>
                </div>

                {/* Section 3 */}
                <div className="md:flex items-center justify-center px-4 py-4">
                    <img src={Carfour} alt="Durability" className="md:w-1/2 w-full rounded-lg" />
                    <div className="md:w-1/3 w-full p-8 bg-white shadow-lg text-center justify-center">
                        <h2
                            className="text-2xl font-bold tracking-widest p-8"
                            style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                        >
                            DURABILITY
                        </h2>
                        <p className="text-gray-800 text-xl leading-normal text-justify" style={{ wordSpacing: '0', hyphens: 'auto' }}>
                            Please note that overall durability may vary depending on the size of the vehicle’sand for our team to complete the PPF process. After installation, the car receives a final wash and is prepared for delivery.
                            We recommend that customers return for a free inspection within 10 days, especially if they wish to ensure everything is in perfect condition.
                            In rare cases where defects arise,we are happy to address them.
                        </p>
                    </div>
                </div>

                {/* Section 4 */}
                <div className="md:flex md:flex-row-reverse items-center justify-center px-4 py-4">
                    <img src={Carfive} alt="Our Prep" className="md:w-1/2 w-full rounded-lg" />
                    <div className="md:w-1/3 w-full p-8 bg-white shadow-lg text-center justify-center">
                        <h2
                            className="text-2xl font-bold tracking-widest p-8"
                            style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                        >
                            OUR PREP
                        </h2>
                        <p className="text-gray-800 text-xl leading-normal text-justify" style={{ wordSpacing: '0', hyphens: 'auto' }}>
                            We use high-quality PPF for both gloss and matte finishes. If you require PPF with a built-in ceramic coating, we also offer that option. The films can be applied on painted and carbon surfaces and feature self-healing properties. When applied correctly, the PPF is virtually invisible while providing a durable layer of protection for several years.
                        </p>
                    </div>
                </div>

                {/* Car Detailing */}
                <section className="relative w-full h-[100vh] p-4">
                    <img src={Carsix} alt="Hero" className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-y-0 right-0 flex items-center justify-end pr-10">
                        <div className="px-6 py-6 text-center rounded-md max-w-3xl text-white">
                            <h2
                                className="text-2xl sm:text-4xl font-bold tracking-widest mb-4"
                                style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                            >
                                CAR DETAILING
                            </h2>
                            <p className="text-lg sm:text-xl leading-relaxed">
                                AKT proud to offer an in-depth detailing service. Our dedicated team will address present issues and then perform steps from deep-cleaning and decontamination, through to paint correction and removal of distorted paint to bring your car back to life. To bring our service to the next level, we also offer Nano Ceramic coating, for your vehicle’s exterior, interior, glass and rims.
                            </p>
                        </div>
                    </div>
                </section>


                {/* Window Tint */}
                <div className="md:flex md:flex-row-reverse items-center justify-center px-4 py-4">
                    <img src={Carseven} alt="Our Prep" className="md:w-1/2 w-full rounded-lg" />
                    <div className="md:w-1/3 w-full p-8 bg-white text-center justify-center shadow-2xl">
                        <h2
                            className="text-2xl font-bold tracking-widest p-8"
                            style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                        >
                            WINDOW TINT AND SAFETY GLASS
                        </h2>
                        <p className="text-gray-800 text-xl leading-normal text-justify" style={{ wordSpacing: '0', hyphens: 'auto' }}>
                            Our high-quality film & tint offers exceptional infrared heat rejection of up to 94–98%, delivering a sleek appearance along with outstanding performance. It helps keep you comfortable and protected in all weather conditions.
                        </p>
                    </div>
                </div>



                {/* Windshield Protection */}
                <section className="relative w-full h-[100vh] p-4">
                    <img src={Carnine} alt="Hero" className="absolute inset-0 w-full h-full object-cover" />
                    <div className="absolute inset-y-0 right-0 flex items-center justify-end pr-10">
                        <div className="px-6 py-6 text-center rounded-md max-w-3xl text-white">
                            <h2
                                className="text-2xl sm:text-4xl font-bold tracking-widest mb-4"
                                style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                            >
                                WINDSHIELD PROTECTION
                            </h2>
                            <p className="text-lg sm:text-xl leading-relaxed">
                                Cracks and chips in your windshield can be expensive and hazardous. We offer high-quality windshield protection film that absorbs the impact of standard road hazards, helping reduce the occurrence of rock chips and pitting.
                            </p>
                        </div>
                    </div>
                </section>

                {/* Premium Storage */}
                {/* <div className="text-center px-4">
                    <h2
                        className="text-2xl sm:text-4xl font-bold tracking-widest mb-4"
                        style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                    >
                        PREMIUM STORAGE
                    </h2>
                    <p className="text-lg sm:text-xl leading-relaxed">Welcome to AKT Premium Storage, our take on providing a luxurious facility<br /> to safely store your vehicle. This service is offered across all our facilities. </p>
                </div>

                <div className="md:flex items-center justify-center px-4 py-4">
                    <img src={Carten} alt="Durability" className="md:w-1/2 w-full rounded-lg" />
                    <div className="md:w-1/3 w-full p-8 bg-white shadow-lg text-center justify-center">
                        <h2
                            className="text-2xl font-bold tracking-widest p-8"
                            style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                        >
                            FACILITY
                        </h2>
                        <p className="text-lg sm:text-xl leading-relaxed">With a limited number of spaces available and a dedicated team of professionals, the care and attention lavished on your vehicle is truly unrivaled. We offer a single package to our clients encompassing tyre cradles, battery tenders/chargers, car covers and regular cleaning (if required). Each car is comprehensively cleaned on delivery, as part of the package.</p>
                    </div>
                </div> */}

                {/* <div className="md:flex md:flex-row-reverse items-center justify-center px-4">
                    <img src={Careleven} alt="Benefits" className="md:w-1/2 w-full" />
                    <div className="md:w-1/3 w-full p-6 bg-white shadow-md">
                        <h3 className="font-semibold text-sm uppercase">Benefits</h3>
                        <ul className="text-sm list-disc list-inside mt-2">
                            <li>Climate controlled</li>
                            <li>24/7 monitored security</li>
                            <li>Battery maintenance</li>
                            <li>Detailing services</li>
                            <li>Flexible storage durations</li>
                        </ul>
                    </div>
                </div> */}
                <div className="md:flex md:flex-row-reverse items-center justify-center px-4 py-4">
                    <img src={Carten} alt="Our Prep" className="md:w-1/2 w-full rounded-lg" />
                    <div className="md:w-1/3 w-full p-8 bg-white shadow-lg text-center justify-center">
                        <h2
                            className="text-2xl font-bold tracking-widest p-8"
                            style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                        >
                            BENEFITS
                        </h2>
                        <ul className="text-lg sm:text-xl text-gray-800 text-left">
                            <li>- Secure, gated buildings</li>
                            <li>- Temperature controlled, dust free</li>
                            <li>- 24/7 on-site security with CCTV monitoring</li>
                            <li>- Surgically clean environment</li>
                            <li>- Kuberth easy-rise tyre cradles</li>
                            <li>- CTEK battery maintainer / charger</li>
                            <li>- Supersoft black fitted car cover</li>
                            <li>- Deep wash upon entry</li>
                            <li>- Monthly washing & starting procedure</li>
                            <li>- Out of hours access available</li>
                            <li>- Dedicated parking spaces</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
